import { _ as _sfc_main } from "./VaTextarea.vue_vue_type_script_lang-0f5534b4.mjs";
import { openBlock, createElementBlock, mergeProps } from "vue";
import { _ as _export_sfc } from "../../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaTextarea_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["value"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("textarea", mergeProps({
    ref: "textarea",
    class: "textarea",
    style: _ctx.computedStyle
  }, { ..._ctx.computedProps, ..._ctx.listeners }, { value: _ctx.modelValue }), null, 16, _hoisted_1);
}
const VaTextarea = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaTextarea as V
};

import '../../../../../VaTextarea.css';
//# sourceMappingURL=VaTextarea-a1156ea9.mjs.map
